/**
 * The routes the dock may be on and may send the reader to.
 *
 * `router.tsx` declares its paths inline; `router.test.tsx` pins that each entry here is a real route
 * under the authenticated full layout, so the two cannot drift apart silently.
 */
export const PAGE_ROUTES = {
  caseReview: "/case-review/case/$caseId",
  workQueue: "/assignment-center/work-queue",
  assignmentCenter: "/assignment-center",
  operations: "/operations",
  caseList: "/list",
  duplicateReview: "/duplicate-review/$caseId",
  intakeTriage: "/intake-triage",
  intakeTriageItem: "/intake-triage/$itemId",
} as const;

export type PageRoute = (typeof PAGE_ROUTES)[keyof typeof PAGE_ROUTES];

/** The allow-list the `navigateTo` frontend tool checks against. */
export const KNOWN_ROUTES: readonly PageRoute[] = Object.values(PAGE_ROUTES);

/** Fills a route template's `$param` segments. Throws on a segment left unfilled. */
export function routeFor(template: PageRoute, params: Record<string, string | number> = {}): string {
  const filled = template.replace(/\$(\w+)/g, (_match, name: string) => {
    const value = params[name];
    if (value === undefined) throw new Error(`Route ${template} needs a value for ${name}`);
    return String(value);
  });
  return filled;
}
